import { cn } from '@/lib/tailwind';
import type { UiGradientOverlayProps } from './UiGradientOverlay.types';
import { uiGradientOverlayStyles } from './UiGradientOverlay.styles';

function UiGradientOverlay({ variant = 'bottom', className }: UiGradientOverlayProps) {
    return (
        <div
            className={cn('pointer-events-none absolute', uiGradientOverlayStyles[variant], className)}
            aria-hidden="true"
        />
    );
}
export default UiGradientOverlay;
